<template>
  <v-container>
    <Tabs :settings="tabSettings"></Tabs>
    <router-view></router-view>
  </v-container>
</template>
<script>
import Tabs from '@/components/Tabs'
import routes from '@/route_names'
export default {
  name: 'AccountsView',
  components: {
    Tabs
  },
  computed: {
    tabSettings: function() {
      const tabs = []
        tabs.push({
          id: routes.ACCOUNTS,
          label: 'Account'
        })
      return {
        preselected: null,
        tabs: tabs
      }
    }
  }
  
}
</script>

<style lang="stylus">
</style>
